import { createContext, type ReactNode, useContext, useState } from "react";

type ContextContent = {
    isActive: boolean;
    setIsActive: (inFocus: boolean) => void;
};

const Context = createContext<ContextContent>({
    isActive: false,
    setIsActive: () => undefined,
});

export const useSortableContext = () => useContext(Context);
export const useSortableIsDisabled = () => !useSortableContext().isActive;

export default function SortableContext({ children }: { children: ReactNode }) {
    const [isActive, setIsActive] = useState<boolean>(false);

    return <Context.Provider value={{ isActive, setIsActive }}>{children}</Context.Provider>;
}
